exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grid-local[data-v-1f54f713]{display:grid;grid-template-columns:200px 1fr;max-width:95%;margin:auto;border-bottom:1px solid #ababab;padding-top:20px;padding-bottom:20px}.grid-title[data-v-1f54f713]{display:grid;grid-template-rows:1fr auto 1fr}.grid-half[data-v-1f54f713]{display:grid;grid-template-columns:1fr 1fr}", ""]);

// exports
